import { normalize } from '../../utils/normalize'
import { 
    SAVE_MATCH as SOCKET_SAVE_MATCH, 
    GET_MATCHES as SOCKET_GET_MATCHES,
    DELETE_MATCH as SOCKET_DELETE_MATCH
} from '../../events/DashboardToServer'
import { selectQuestionsByMatch } from '../questions';
import { START_MATCH as SOCKET_START_MATCH, STOP_MATCH as SOCKET_STOP_MATCH } from '../../events/DashboardToServer'

export const SAVE_MATCH = 'SAVE_MATCH'
export const SAVED_MATCH = 'SAVED_MATCH'
export const GET_MATCHES = 'GET_MATCHES'
export const RECEIVE_MATCHES = 'RECEIVE_MATCHES'
export const DELETE_MATCH = 'DELETE_MATCH'
export const DELETED_MATCH = 'DELETED_MATCH'
export const START_MATCH = 'START_MATCH'
export const STARTED_MATCH = 'STARTED_MATCH'
export const STOP_MATCH = 'STOP_MATCH'
export const STOPPED_MATCH = 'STOPPED_MATCH'


export const matches = (state = {}, action) => {
    switch (action.type) {
        case SAVE_MATCH:
            return Object.assign({}, state, normalize(state, [{ ...action.match, updating: true , password:action.password}]))

        case SAVED_MATCH:
            const newState = Object.assign({}, state, normalize(state, [{ ...action.match, updating: false, password:action.password }]))
            const { prevId } = action
            if (prevId && prevId !== action.match.id && newState[prevId])
                delete newState[prevId]
            return newState

        case RECEIVE_MATCHES:
            return Object.assign({}, state, normalize(state, action.matches))

        case DELETE_MATCH:
            return {
                ...state,
                [action.game_id]: {
                    ...state[action.game_id],
                    deleting: true
                }
            }

        case DELETED_MATCH:
            const deletedState = { ...state }
            delete deletedState[action.match.game_id]
            return deletedState

        case START_MATCH:
            return {
                ...state,
                [action.game_id]: {
                    ...state[action.game_id],
                    isStarting: true
                }
            }

        case STARTED_MATCH:
            return {
                ...state,
                [action.match.id]: {
                    ...state[action.match.id],
                    ...action.match,
                    isStarting: false
                }
            }

        case STOP_MATCH:
            return {
                ...state,
                [action.game_id]: {
                    ...state[action.game_id],
                    isStopping: true
                }
            }

        case STOPPED_MATCH:
            return {
                ...state,
                [action.match.id]: {
                    ...state[action.match.id],
                    ...action.match,
                    isStopping: false
                }
            }

        default:
            return state
    }
}

// actions

export const saveMatch = (socket, match, questions, password) => {
    socket.emit(SOCKET_SAVE_MATCH, {match, questions, password})
    return { type: SAVE_MATCH, match, questions, password}
}

export const savedMatch = (match, prevId, question_game, password) => {
    return { type: SAVED_MATCH, match, prevId , question_game, password}
}

export const getMatches = (socket) => {
    socket.emit(SOCKET_GET_MATCHES)
    return { type: GET_MATCHES }
}

export const receiveMatches = (matches) => {
    return { type: RECEIVE_MATCHES, matches }
}

export const deleteMatch = (socket, game_id) => {
    socket.emit(SOCKET_DELETE_MATCH,  game_id )
    return { type: DELETE_MATCH, game_id }
}

export const deletedMatch = (match) => {
    return { type: DELETED_MATCH, match }
}

export const startMatch = (socket, game_id, live_video_url, password) => {
    socket.emit(SOCKET_START_MATCH, { game_id, live_video_url, password })
    return { type: START_MATCH, game_id }
}

export const startedMatch = (match) => {
    return { type: STARTED_MATCH, match }
}

export const stopMatch = (socket, game_id) => {
    socket.emit(SOCKET_STOP_MATCH, { game_id })
    return { type: STOP_MATCH, game_id }
}

export const stoppedMatch = ({ id, ending_time }) => {
    return { type: STOPPED_MATCH, match: { id, ending_time } }
}


// selectors

export const selectMatches = (state) => {
    return Object.keys(state.matches).map(id => state.matches[id])
}

export const selectMatch = (state, game_id) =>{
    return state.matches[game_id]
}

export const selectQuestionsCount = (state, game_id) => {
    const matchQuestions = selectQuestionsByMatch(state, game_id)
    return matchQuestions.length ||
        (state.matches[game_id] && state.matches[game_id].questionsCount) ||
        0
}


// WEBPACK FOOTER //
// ./src/reducers/matches/index.js